import { NgForm } from '@angular/forms';
import { ViewChild, Directive } from '@angular/core';

// import { Location } from '@angular/common';
// import * as $ from 'jquery';
// import { ConfirmacaoService } from '../confirmacao/confirmacao.service';
// import { DomEventUtil } from '../framework/utils/dom-event-util';

@Directive()
export abstract class FormComponent {
  

  public pId: number;
  @ViewChild('f') public ngForm: NgForm;

  // Create our number formatter.
  private formatter = new Intl.NumberFormat('pt-BR', {
    // style: 'currency',
    // currency: 'BRL',
    // These options are needed to round to whole numbers if that's what you want.
    // minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    maximumFractionDigits: 2 // (causes 2500.99 to be printed as $2,501)
  });


  constructor(
    // private _confirmacaoService?: ConfirmacaoService,
    // private _location?: Location
  ) {
    const context = this;
    setTimeout(() => {
      this.ativarAtalhos(context);
    }, 2000);
  }

  inserir() {
    throw new Error('Method Inserir() not implemented.');      
  }

  atualizar() {
    throw new Error('Method Atualizar() not implemented.');
  }

  excluir() {
    throw new Error('Method Excluir() not implemented.');
  }

  voltar() {
    // if ( this._location ) {
    //   this._location.back();
    // }
  }

  ativarAtalhos(context: any) {
    // if ( !this._confirmacaoService ) {
    //   return;
    // }

    // var self = new DomEventUtil(context, this._confirmacaoService);
    // $('body').on('keyup', function(e) {
    //   self.onKeyUp(e);
    // });
  }

  formatarMoeda(event: any, ngObject: any): void {
    try {
      let valorOriginal = event.target.value;
      if ( valorOriginal ) {
        valorOriginal = valorOriginal.replace(/\D/g, '');
        let valorFormatado = (parseFloat(valorOriginal) / 100).toFixed(2);
        event.target.value = valorFormatado;
        ngObject = valorFormatado;
      }
    }
    catch (e) {
      console.error('app.form :: formatarMoeda', e);
    }
  }

  apenasNumeros(event: any): boolean {
    if ( event && event.key ) {
      return /^[\d.?!]+$/.test(event.key);
    }

    return false;
}

  apenasInteiros(event: any): boolean {
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode >= 48 && charCode <= 57) {
          return true;
      }
      return false;
  }

}
